const ResizeFieldIcon = /*#__PURE__*/ [
  ["path", { d: "M16 18.0002L18 16.0002M11 18.0002L18 11.0002M6 18L18 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export { ResizeFieldIcon as default };
//# sourceMappingURL=ResizeFieldIcon.js.map
